export const ZINDEXES = {
  FULLSCREEN_VIEWER_LAYER: 6,
  HEADER_LAYER: 5,
  CONTENT_LAYER: 0,
  MOBILE_MENU_LAYER: 1,
  VIEWER_LAYER: 0,
  VIEWER_LOADING_LAYER: 2,
  BANNER: 2,
  SUBHEADER_LAYER: 1
}
